import React, { useEffect } from "react";
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import AboutUs from '../components/AboutUs';
import TeamAndAdvisors from '../components/TeamAndAdvisors';
import OurClients from '../components/OurClients';
import ContactUs from '../components/ContactUs';

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const section = document.querySelector(window.location.hash);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <>
      <HeroSection />
      <AboutUs />
      <ServicesSection />
      <TeamAndAdvisors />
      <OurClients />
      <ContactUs />
    </>
  );
};

export default Home;
